// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recurrence-popup__header[data-v-e37a3166]{font-size:16px;padding:10px 0;font-style:italic;font-weight:bold;color:#9c9c9c}\n", ""]);
// Exports
module.exports = exports;
